import React, { Component } from 'react';
import { asyncComponent } from 'react-async-component';
import PropTypes from 'prop-types';

const Twitter = asyncComponent({
    resolve: () => import('./Twitter'),
});

export default class TwitterWrapper extends Component {
    render() {
        return(
            <div>
                <Twitter config={this.props.config} reportEvent={this.props.reportEvent(this.props.config.universal_id)} />
            </div>
        );
    }
}

TwitterWrapper.propTypes = {
    config: PropTypes.object.isRequired,
};
